module.exports = __webpack_public_path__ + "distribution-logo-podcast.54c8dc2a74516ca7ecf4163430bc6c77.svg";